// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__VinNh"};